import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TechnicalService } from 'src/app/interfaces';

/**
 * List of Technical services
 *
 * @export
 * @class StaListComponent
 */
@Component({
  selector: 'app-sta-list',
  templateUrl: './sta-list.component.html',
  styleUrls: ['./sta-list.component.scss'],
})
export class StaListComponent {
  /**
   * Technical services to show in the list
   *
   * @type {TechnicalService[]}
   * @memberof StaListComponent
   */
  @Input() technicalServices: TechnicalService[] = [];

  /**
   * Event emitter to comunicate with others components
   *
   * @type {EventEmitter<TechnicalService>}
   * @memberof StaListComponent
   */
  @Output() itemDetail: EventEmitter<TechnicalService> = new EventEmitter();

  /**
   * Emit an event with the technical service
   *
   * @param {TechnicalService} technicalService
   * @memberof StaListComponent
   */
  showItemDetail(technicalService: TechnicalService) {
    this.itemDetail.emit(technicalService);
  }

  /**
   * Track by item index
   *
   * @param {number} index
   * @returns
   * @memberof StaListComponent
   */
  trackByFunction(index: number) {
    return index;
  }
}
